export default __webpack_public_path__ + "static/media/foto_01.a39fe5de.jpg";